class DataLoader {
  constructor() {
    this.loadingPromises = new Map();
  }

  load(url) {
    const urls = Array.isArray(url) ? url : [url];
    const key = urls.join('|');

    if (this.loadingPromises.has(key)) {
      return this.loadingPromises.get(key);
    }

    const promise = this._tryLoadSequential(urls).finally(() => {
      this.loadingPromises.delete(key);
    });

    this.loadingPromises.set(key, promise);
    return promise;
  }

  async loadAll(urls) {
    return Promise.all(urls.map((url) => this.load(url)));
  }

  async _tryLoadSequential(urls) {
    let lastError = null;
    for (const url of urls) {
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Failed to load ${url}: ${response.status}`);
        }
        return await response.json();
      } catch (error) {
        lastError = error;
      }
    }
    throw lastError || new Error('Failed to load data');
  }
}

export const dataLoader = new DataLoader();
